import { IBaseCellsProps } from '../cells.interfaces';
import { StyledTableCell } from './CellCheckbox.styles';
import { Checkbox } from '../../../base-components';

interface Props extends IBaseCellsProps {
    isItemSelected?: boolean;
    indeterminate?: boolean;
    onSelectionChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isHeaderCell?: boolean;
    disabled?: boolean;
}
const CellCheckbox = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        isItemSelected = false,
        indeterminate = false,
        onSelectionChange,
        isHeaderCell = false,
        disabled = false,
    } = props;
    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
            isHeaderCell={isHeaderCell}
        >
            <Checkbox
                color="primary"
                checked={isItemSelected}
                indeterminate={indeterminate}
                onChange={onSelectionChange}
                disabled={disabled}
                sx={{
                    width: 20,
                    height: 20,
                    '& .MuiSvgIcon-root': {
                        fontSize: 20,
                    },
                }}
            />
        </StyledTableCell>
    );
};

export default CellCheckbox;
